var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-field',{staticClass:"tw-flex-shrink",attrs:{"label":"Advisory Fee","label-size":"small"}},[_c('o-input',{staticClass:"tw-w-24",attrs:{"placeholder":"0.05","type":"number","size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }